import { render } from "./MessageListItem.vue?vue&type=template&id=fd392e5e&scoped=true"
import script from "./MessageListItem.vue?vue&type=script&lang=js"
export * from "./MessageListItem.vue?vue&type=script&lang=js"

import "./MessageListItem.vue?vue&type=style&index=0&id=fd392e5e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd392e5e"]])

export default __exports__